enum DeliveryTableReport {
  Date = 'delivery_table_date',
  Channel = 'delivery_table_channel',
  Device = 'delivery_table_device',
  Advertiser = 'delivery_table_advertiser',
  Campaign = 'delivery_table_campaign',
  Placement = 'delivery_table_placement',
  Creative = 'delivery_table_creative',
  Publisher = 'delivery_table_publisher',
  DayOfWeek = 'delivery_table_day_of_week',
  Daypart = 'delivery_table_daypart',
  Genre = 'delivery_table_genre',
  VenueType = 'delivery_table_venue_type',
  Deals = 'delivery_table_deals',
  GeoState = 'delivery_table_geo_state',
  GeoDMA = 'delivery_table_geo_dma',
  GeoCounty = 'delivery_table_geo_county',
  GeoZip = 'delivery_table_geo_zip',
  GeoCongressionalDistrict = 'delivery_table_geo_congressional_district',
  GeoCity = 'delivery_table_geo_city',
  GeoFence = 'delivery_table_geo_fence',
}

export default DeliveryTableReport;
